import { makePushEvent } from '@devicebits/analytics-client';
import { getPermanentId } from '../util/get-permanent-id';
import { getAppInstanceId } from '../util/get-app-instance-id';

const IS_DEV = window.location.origin.includes('localhost');
console.log('Dev', IS_DEV);

const appStartTime = new Date();

/**
 * The makePushEvent function is a factory function that returns a pushEvent function.
 * The pushEvent function takes an event object or array of event objects and pushes them
 * to the analytics API.
 *
 * @todo add env var for dev/production after testing ingestion
 *
 * @param {object} options - Options for the pushEvent function
 * @param {object} options.baseProps - The properties that will be added to each event
 * @param {number} options.debounceDelay - The delay in milliseconds to wait before sending the events
 * @param {function} options.handlePartialFailure - A function that will be called if there was a partial failure when posting events
 * @returns A function that takes an event object and returns a promise
 */
const pushEvent = makePushEvent({
  apiUrl: `${IS_DEV ? 'https://analytics.devicebits.com/dev' : 'https://analytics.devicebits.com/v1'}/analytics/bot`,
  // apiUrl: `${process.env.ANALYTICS_API || 'https://analytics.devicebits.com/dev'}/analytics/bot`,
  debounceDelay: 5000,

  baseProps: {
    app_instance_id: getAppInstanceId(),
    app_instance_time: () => (
      (new Date() - appStartTime).toString()
    ),
    page: () => ({
      url: window.location.href,
    }),
    referrer: () => ({
      url: document.referrer,
    }),
    user_agent: navigator.userAgent,
    permanent_id: getPermanentId(),
    botName: () => sessionStorage.getItem('bot_name'),
    botId: () => sessionStorage.getItem('bot_id'),
    user_email: () => localStorage.getItem('user_email'),
    call_session_id: () => sessionStorage.getItem('call_session_id'),
  },
});

export default pushEvent;
